<template>
  <v-navigation-drawer
    :value.sync="drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    class="tw-pb-28 tw-border-0 md:tw-pb-0 md:tw-border-r-1 md:tw-border-light-gray md:tw-border-solid"
  >
    <!-- isValid isPdfDoc {{ isValid(selectedCompanyProductList.isPdfDoc) }}
    <br />
    isValid isEtax {{ isValid(selectedCompanyProductList.isEtax) }}
    <br />
    isValid isExchangeRate {{ isValid(selectedCompanyProductList.isExchangeRate) }} -->
     <!-- {{ selectedCompanyProductList }} -->
     <!-- userCompany {{ userCompany?.isAdmin }} -->
    <br />
    <div :class="`d-flex justify-center pt-5 pb-5`">
      <img
        src="@/assets/logo_phasi_charoen.svg"
        alt="ภาษีเจริญ"
        width="120"
        style="cursor: pointer"
        @click="goHome"
      />
    </div>
    <v-list v-if="!isItemLoading" style="margin-top: 10%">
      <!-- // etax // -->
      <template v-if="isValid(selectedCompanyProductList?.isEtax)">
        <div v-for="(item, index) in itemsPSC" :key="index + '_psc'">
          <menu-list :item="item" :companyID="companyID"></menu-list>
        </div>
      </template>
      <!-- // Ar automation // -->
      <template v-if="isValid(selectedCompanyProductList?.isPdfDoc)">
        <div v-for="(item, index) in itemsVendor" :key="index + '_vendor'">
          <menu-list :item="item" :companyID="companyID" :isPdfDoc="isValid(selectedCompanyProductList?.isPdfDoc)"></menu-list>
        </div>
      </template>
      <!-- // exchange rate // -->
      <div v-if="isValid(selectedCompanyProductList?.isExchangeRate)">
        <div v-for="(item, index) in itemsExchangeRate" :key="index + '_exchange'">
          <menu-list :item="item" :companyID="companyID"></menu-list>
        </div>
      </div>
      <!-- // nsThaiSmartTax // --> 
      <div v-if="isValid(selectedCompanyProductList?.isNsThaiSmartTax)">
        <div v-for="(item, index) in itemsNsThaiSmartTax" :key="index + '_nstax'">   
          <div v-if="item.link==='Company.TaxBuyAverage' && selectedCompanyProductList?.isNsThaiSmartTaxAverage">
            <menu-list :item="item" :companyID="companyID" :isNsThaiSmartTax="isValid(selectedCompanyProductList?.isNsThaiSmartTax)"></menu-list>
          </div>
          <div v-else-if="item.link !=='Company.TaxBuyAverage'" >
            <menu-list :item="item" :companyID="companyID" :isNsThaiSmartTax="isValid(selectedCompanyProductList?.isNsThaiSmartTax)"></menu-list>
          </div>

         <!-- <menu-list :item="item" :companyID="companyID" :isNsThaiSmartTax="isValid(selectedCompanyProductList?.isNsThaiSmartTax)"></menu-list> -->
        </div>
      </div>
      <!-- // top serv // -->
      <div v-if="isValid(selectedCompanyProductList?.isTopserv)">
        <div v-for="(item, index) in itemsTKC" :key="index + '_tkc'">
          <menu-list :item="item" :companyID="companyID"></menu-list>
        </div>
      </div>
  <!-- when on the “student” company, render the student items -->
   <div
     v-if="companyID === 'mNX8y3SDqm5PcWLfdBGK'"
     class="tw-mb-4"
   >
     <div
       v-for="(item, idx) in itemsApAutomateStudent"
       :key="`student_${idx}`"
     >
       <menu-list
         v-if="!item.onlydev || (userCompany?.isDeveloper || userCompany?.user?.isEngineer)"
         :item="item"
         :companyID="companyID"
         :isCompanyAdmin="userCompany?.isAdmin"
       ></menu-list>
     </div>
   </div>
   <!-- otherwise, fall back to the normal AP-Automate items -->
   <div
     v-else-if="isValid(selectedCompanyProductList?.isApAutomate)"
     class=""
   >
     <div
       v-for="(item, idx) in itemsApAutomate"
       :key="`apauto_${idx}`"
     >
       <menu-list
         v-if="!item.onlydev || (userCompany?.isDeveloper || userCompany?.user?.isEngineer)"
         :item="item"
         :companyID="companyID"
         :isCompanyAdmin="userCompany?.isAdmin"
       ></menu-list>
     </div>
   </div>
      <!-- if none of those are true, then show the default menu -->
      <template v-if="!isValid(selectedCompanyProductList?.isEtax) && !isValid(selectedCompanyProductList?.isPdfDoc) && !isValid(selectedCompanyProductList?.isExchangeRate) && !isValid(selectedCompanyProductList?.isTopserv)  && !isValid(selectedCompanyProductList?.isNsThaiSmartTax) && !isValid(selectedCompanyProductList?.isApAutomate)">
        <div v-for="(item, index) in itemsPSC" :key="index">
          <menu-list :item="item" :companyID="companyID"></menu-list>
        </div>
      </template>
      <!-- NS Fixed asset count -->
     <div v-if="isValid(selectedCompanyProductList?.isFixedAssetCount)">
        <div v-for="(item, index) in itemsNsFixedAsset" :key="index + '_nsfixedasset'">   
      
         <menu-list :item="item" :companyID="companyID" :isFixedAssetCount="isValid(selectedCompanyProductList?.isFixedAssetCount)"></menu-list>
        </div>
      </div>
      <div
        v-if="!isItemLoading && companyID !== 'mNX8y3SDqm5PcWLfdBGK'"
      >
        <menu-list :item="itemsSetting" :companyID="companyID"></menu-list>
      </div>
    </v-list>
    <!-- loading indicator -->
    <div v-else style="margin-top: 10%">
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      <div class="tw-ml-20 tw-mr-10">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      <div class="tw-ml-20 tw-mr-10">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
    </div>

  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import MenuList from "@/components/admin/navigation/list.vue";
import router from "@/router";
import fc from "@/firebaseConfig";
const PRODUCT_GROUP = {
  PSC: "PSC",
  PDFAI: "PDFAI",
  FRX: "FRX",
};

export default {
  name: "NavigationDrawer",
  data: () => ({
    companyID: "",
    vendorListMerged: false,
    currentItems: [],
    unsubscribe: [],
  }),
  components: {
    MenuList,
  },
  computed: mapState({
    userCompany: (state) => state.user.userCompany,
    drawer: (state) => state.drawer.open,
    itemsPSC: (state) => state.drawer.itemsPSC,
    isItemLoading: (state) => state.drawer.isItemLoading,
    itemsVendor: (state) => state.drawer.itemsVendor,
    itemsExchangeRate: (state) => state.drawer.itemsExchangeRate,
    itemsNsThaiSmartTax: (state) => state.drawer.itemsNsThaiSmartTax,
    itemsNsFixedAsset: (state) => state.drawer.itemsNsFixedAsset,
    itemsTKC: (state) => state.drawer.itemsTKC,
    itemsApAutomate: (state) => state.drawer.itemsApAutomate,
    itemsApAutomateStudent: (state) => state.drawer.itemsApAutomateStudent,
    itemsSetting: (state) => state.drawer.itemsSetting,
    vendorPOList: (state) => state.drawer.vendorPOList,
    vendorSOList: (state) => state.drawer.vendorSOList,
    selectedCompanyAutoDocConfig: (state) => state.companies.selectedCompanyAutoDocConfig,
    selectedCompanyProductList: (state) => state.companies.selectedCompanyProductList,
  }),
  created() {
    this.companyID = this.$route.params.companyId;
    // if (this.companyID === "Eh3hXbMX82kanH0deWiv") {
      this.getCompanyAutoDocConfig();
      this.getCompanyProductList();
    // }

    if (this.companyID) {
      this.$store.dispatch("user/getRoleUser", { companyId: this.companyID });
    }

  },
  beforeDestroy() {
      this.unsubscribe.forEach((unsubscribe) => {
        unsubscribe();
      });
  },
  methods: {
    getCompanyAutoDocConfig() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getCompanyAutoDocConfig", { companyId });
    },
    getCompanyProductList() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getCompanyProductList", { companyId });
    },
    isValid(value) {
      return (
        value !== undefined && value !== null && value !== "" && value === true
      );
    },
    goHome: function () {
      router.push("/");
    },
    mergeVendorListOnce() {
      this.$store.commit("drawer/mergeVendorList");
      this.$store.commit("drawer/setVendorListMerged");
    },
    setNewPOList() {
      // console.log("setNewPOList -> selectedCompanyAutoDocConfig", this.selectedCompanyAutoDocConfig.length)

      const newPoList = this.selectedCompanyAutoDocConfig.map((item) => ({
        text: item.vendorName,
        link: "Company.DocumentPOAIVendor",
        vendorCode: item.vendorCode,
      }));

      //check if item inside vendorPoList is different from newPoList

      const isDifferent =
        JSON.stringify(this.vendorPOList) !== JSON.stringify(newPoList);

      if (
        !this.$store.state.drawer.vendorListMerged ||
        this.vendorPOList.length !== newPoList.length ||
        isDifferent
      ) {
        this.$store.commit("drawer/setVendorPOList", newPoList);
        this.mergeVendorListOnce();
      }
    },
    setNewVendorList() {
      // console.log("setNewPOList -> selectedCompanyAutoDocConfig", this.selectedCompanyAutoDocConfig.length)
      

      const newPoList = this.selectedCompanyAutoDocConfig.map((item) => ({
        text: item.vendorName,
        link: "Company.DocumentPOAIVendor",
        subIcon: item.logo,
        vendorCode: item.vendorCode,
        group: PRODUCT_GROUP.PDFAI,
      }));
      const newSoList = this.selectedCompanyAutoDocConfig.map((item) => ({
        text: item.vendorName,
        link: "Company.DocumentSOAIVendor",
        subIcon: item.logo,
        vendorCode: item.vendorCode,
        group: PRODUCT_GROUP.PDFAI,
      }));

      //check if item inside vendorPoList is different from newPoList

      const isDifferent =
        JSON.stringify(this.vendorPOList) !== JSON.stringify(newPoList);
      const isDifferentSO =
        JSON.stringify(this.vendorSOList) !== JSON.stringify(newSoList);

      if (
        !this.$store.state.drawer.vendorListMerged ||
        isDifferent ||
        isDifferentSO
      ) {
        this.$store.commit("drawer/setVendorPOList", newPoList);
        this.$store.commit("drawer/setVendorSOList", newSoList);
        this.mergeVendorListOnce();
      }
    },
    setTkcItem(){
      const companyId = this.$route.params.companyId;
      const snapshot = fc.companies.doc(companyId).collection("TopservInvoiceSettings").doc("TOPSERV").onSnapshot(
        (doc) => {
          if (doc.exists) {
            const data = doc.data();
            const tkcItem = data.branches.map((item) => ({
              text: `สาขา${item.branchName} (${item.endsWith})`,
              link: "Company.DocumentTOPSERVBranch",
              endsWith: item.endsWith,
            }));
            this.$store.commit("drawer/setitemsTKC", tkcItem);
          }
        }
      );
      this.unsubscribe.push(snapshot);
    }
  },
  watch: {
    selectedCompanyAutoDocConfig() {
      // this.setNewPOList();
      this.setNewVendorList();
      // console.log("Watch -> selectedCompanyAutoDocConfig", this.selectedCompanyAutoDocConfig.length)
    },
    selectedCompanyProductList() {
      if (this.selectedCompanyProductList?.isTopserv) {
        this.setTkcItem();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-list {
  margin-bottom: 100px;
}
</style>
